import { render } from "./Logo.vue?vue&type=template&id=eb247816"
const script = {}

const cssModules = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=eb247816&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__